// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pNBaY","memberImage":"styles_memberImage__pZo9x","memberContent":"styles_memberContent__zQp4z"};